const CURRENCY = "PKR";
const PIXEL_ID = "3503254236504848";
const FIRED_KEY = "rd_fb_purchases";

const fb = (...args) => {
    try {
        if (typeof window.fbq === "function") window.fbq(...args);
    } catch {
        /* never break the storefront */
    }
};

const payload = (product, bundle) => {
    const qty = Math.max(1, Number(bundle?.quantity) || 1);
    const total = Number(bundle?.price) || 0;
    return {
        content_ids: [product?.slug],
        content_name: product?.name,
        content_type: "product",
        contents: [{ id: product?.slug, quantity: qty, item_price: Math.round(total / qty) }],
        num_items: qty,
        value: total,
        currency: CURRENCY,
    };
};

const sha256 = async (value) => {
    const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
};

const AM_KEY = "rd_fb_am";
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const sameData = (a, b) => ["em", "ph", "external_id"].every((k) => (a?.[k] || "") === (b?.[k] || ""));

// Re-init with hashed user data so all following pixel events carry it.
const applyMatch = (data) => {
    if (!Object.keys(data).length || sameData(window.__rdFbAm, data)) return;
    window.__rdFbAm = data;
    fb("init", PIXEL_ID, data);
};

export function fbRestoreMatch() {
    try {
        const saved = JSON.parse(localStorage.getItem(AM_KEY) || "null");
        if (saved && typeof saved === "object") applyMatch(saved);
    } catch {
        /* ignore */
    }
}

export async function fbAdvancedMatch({ email, phone }) {
    try {
        if (!window.crypto?.subtle) return;
        const data = { ...(window.__rdFbAm || {}) };
        const e = (email || "").trim().toLowerCase();
        const local = (phone || "").replace(/\D/g, "").replace(/^92/, "").replace(/^0/, "");
        if (EMAIL_RE.test(e)) data.em = await sha256(e);
        if (/^3\d{9}$/.test(local)) {
            data.ph = await sha256(`92${local}`);
            data.external_id = data.ph;
        }
        applyMatch(data);
        localStorage.setItem(AM_KEY, JSON.stringify(window.__rdFbAm || data));
    } catch {
        /* ignore */
    }
}

export const fbViewContent = (product) => {
    if (product?.bundles?.length) fb("track", "ViewContent", payload(product, product.bundles[0]));
};

export const fbAddToCart = (product, bundle) => {
    if (product && bundle) fb("track", "AddToCart", payload(product, bundle));
};

export const fbInitiateCheckout = (product, bundle) => {
    if (product && bundle) fb("track", "InitiateCheckout", payload(product, bundle));
};

export async function fbPurchase(order, { email, phone } = {}) {
    if (!order?.order_number || !order?.total_price) return;
    let fired = [];
    try {
        fired = JSON.parse(localStorage.getItem(FIRED_KEY) || "[]");
    } catch {
        fired = [];
    }
    if (fired.includes(order.order_number)) return;
    try {
        localStorage.setItem(FIRED_KEY, JSON.stringify([...fired, order.order_number].slice(-50)));
    } catch {
        /* ignore */
    }
    await fbAdvancedMatch({ email, phone });
    const qty = Math.max(1, Number(order.bundle_quantity) || 1);
    fb(
        "track",
        "Purchase",
        {
            content_ids: [order.product_slug],
            content_name: order.product_name,
            content_type: "product",
            contents: [{ id: order.product_slug, quantity: qty, item_price: Math.round((Number(order.subtotal) || Number(order.total_price)) / qty) }],
            num_items: qty,
            value: Number(order.total_price),
            currency: CURRENCY,
            order_id: order.order_number,
        },
        { eventID: order.order_number },
    );
}
